export default class DynamicFormFields {
    constructor(form) {
        this.form = form;
        this.radioInputFields = this.getRadioInputFields();
        this.famSection = this.form.querySelector('.family-members');
        // this.preSelectFirstEntry()
        this.listener();
    }
    preSelectFirstEntry() {
        this.radioInputFields[0].checked = true;
    }
    listener() {
        // set the checked value
        this.radioInputFields.forEach(radioInputField => {
            radioInputField.addEventListener('change', () => {
                if (radioInputField.checked) {
                    this.checkedInputValue = radioInputField.value;
                }
                this.showHideFamSection();
            });
        });
    }
    // get all rdaio input fields
    getRadioInputFields() {
        const radioWrapper = this.form.querySelector('[data-name="mitgliedsbeitrag"]');
        return Array.from(radioWrapper.querySelectorAll('input'));
    }
    /**
     * if the option fam was chosen show fam section else hide
    */
    showHideFamSection() {
        if (this.checkedInputValue.toString().includes('Familien')) {
            this.famSection.classList.add('visible');
        }
        else {
            this.famSection.classList.remove('visible');
        }
    }
}
